//src/styles/custom/borders.js

import palette from "../palette";

const borders = {
  light: `1px solid ${palette.raw?.border || "#e0e0e0"}`,
  medium: `2px solid ${palette.raw?.border || "#bdbdbd"}`,
  heavy: `3px solid ${palette.primary?.main || "#1976d2"}`,
  highlight: `1px solid ${palette.secondary?.main || "#ff9800"}`,
};

export default borders;